
import Speedometer from "../../../assets/duotone/Speedometer.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SpeedometerIcon({ className, dataTestid = "SpeedometerIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Speedometer data-testid={dataTestid} className={classes} {...rest} />
  );
}
